module.exports = __webpack_public_path__ + "assets/img/Type E (7).42f30b10.jpg";